import React, { useState } from 'react';

import StockMobileSidePanel from '@/components/StockMobileSidePanel';
import { OptionType } from '@/typings/common';
import { useTypedDispatch, useTypedSelector } from '@/store/store';
import {
  getSelectedFilters,
  getStockFilterParams,
  setCarLocations,
  setPage,
} from '@/store/reducers/cars-stock';
import {
  convertFilterParamsToOptionsByKey,
  handleChangeMultiSelect,
} from '@/modules/CarsStock/components/common.helpers';
import StockFilterMultiSelect from '@/components/StockFilterMultiSelect';

import {
  FilterButton,
  FilterButtonWrapper,
  MobileFilterItemWrapper,
} from '../../../../../../../common.styles';

function LocationFilter() {
  const dispatch = useTypedDispatch();
  const stockFilterParams = useTypedSelector(getStockFilterParams);
  const selectedLocation =
    useTypedSelector(getSelectedFilters).selectedParams.selectedLocation;
  const [isOpened, setOpened] = useState(false);

  const locationsOptions = convertFilterParamsToOptionsByKey(
    stockFilterParams,
    'locations'
  );

  const handleSidePanelOpen = () => {
    setOpened(true);
  };

  const handleSidePanelClose = () => {
    setOpened(false);
  };

  const handleChangeLocation = (location: OptionType) => {
    dispatch(
      setCarLocations(handleChangeMultiSelect(location, selectedLocation))
    );
    dispatch(setPage(1));
  };

  const handleClearLocation = () => {
    dispatch(setCarLocations([]));
    dispatch(setPage(1));
  };

  return (
    <StockMobileSidePanel
      title="Локация"
      zIndex={10001}
      isInnerSidePanel
      isOpened={isOpened}
      onOpen={handleSidePanelOpen}
      onClose={handleSidePanelClose}
    >
      <MobileFilterItemWrapper>
        <StockFilterMultiSelect
          options={locationsOptions}
          selectedOptions={selectedLocation}
          onChange={handleChangeLocation}
          onClear={handleClearLocation}
        />
      </MobileFilterItemWrapper>

      <FilterButtonWrapper>
        <FilterButton onClick={handleSidePanelClose}>Применить</FilterButton>
      </FilterButtonWrapper>
    </StockMobileSidePanel>
  );
}

export default LocationFilter;
